import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.832 116.303A17.84 17.833 0 0 0 5.39 146.908L237.27 378.71a17.84 17.833 0 0 0 25.216 0l231.882-231.802a17.84 17.833 0 1 0-25.216-25.208L249.846 340.932 30.605 121.7a17.84 17.833 0 0 0-12.773-5.397" }, null, -1)
  ])))
}
export default { render: render }